"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogPopupCssVars = void 0;
let DialogPopupCssVars = exports.DialogPopupCssVars = /*#__PURE__*/function (DialogPopupCssVars) {
  /**
   * Indicates how many dialogs are nested within.
   * @type {number}
   */
  DialogPopupCssVars["nestedDialogs"] = "--nested-dialogs";
  return DialogPopupCssVars;
}({});